export enum IdentificationTypeEnum {
  MyKad = '1',
  CompanyRegistrationNo = '2',
  Passport = '3',
  TIN = '4',
}
